import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ApiCaller } from '@frontend/api'
import { LoadingSpinner, Tooltip } from '@ui/components'

import { useMessageContext } from '../../modules/Message'

export default function UserMessageActions() {
	const { onRephrase } = useMessageContext()

	const [isOptimizing, setIsOptimizing] = useState(false)

	async function handleOptimize() {
		ApiCaller.track('Rephrase_query')
		if (onRephrase) {
			setIsOptimizing(true)
			await onRephrase()
			setIsOptimizing(false)
		}
	}

	if (!onRephrase) {
		return null
	}

	return (
		<>
			<button
				className="text-sm text-gray-400 flex items-center gap-2 absolute bottom-[-11px] right-4 max-w-full h-[24px]
					px-3 p-1 border bg-gray-50 rounded-2xl hover:bg-gray-100 active:bg-gray-200 transition-all"
				disabled={ isOptimizing }
				data-tooltip="optimize-tt"
				onClick={ handleOptimize }
			>
				{
					isOptimizing
						? (
							<>
								<div className="w-5">
									<LoadingSpinner size="small" />
								</div>
								<span>
								Optimizing Prompt...
								</span>
							</>
						)
						: (
							<>
								<div className="w-5">
									<FontAwesomeIcon icon="robot" />
								</div>
								<span>
								Optimize Prompt
								</span>
							</>
						)
				}
			</button>
			<Tooltip anchor="optimize-tt">
				VirtualBrain will suggest a better version of your prompt, ready to use below.
			</Tooltip>
		</>
	)
}
